'use strict';

import * as dom from './lib/dom.js';

// function loadComents(e) {
// 	e.preventDefault();
// 	const loadComentsBtn = document.querySelector('.js-load-coments');
//     const targetHtml = document.querySelector('.js-comments-content');
//     let timeoutDelay = 0;

//     dom.addClass(targetHtml, 'c-comments-content--loading');
//     loadComentsBtn.parentNode.removeChild(loadComentsBtn);

//     const u = "brainstorm9";
//     let s = document.createElement('script');
//     s.src = "https://" +u+ ".disqus.com/embed.js";
//     s.async = 'true';
//     document.getElementsByTagName('head')[0].appendChild(s);


//     const checkLoadedIframe = () => {
//         console.log('checkLoadedIframe');
//         const commentsIframe = document.querySelector('#disqus_thread iframe');
//         console.log(commentsIframe);
//         setTimeout(function(){
//             if (commentsIframe !== null) {
//                 dom.removeClass(targetHtml, 'c-comments-content--loading');
//             } else {
//                 timeoutDelay = timeoutDelay + 100;
//                 checkLoadedIframe();
//             }
//         }, timeoutDelay);
//     }

//     checkLoadedIframe();


// }

export default function(){
    const is_single = document.querySelector('.single');

    if (is_single) {
        window.addEventListener('load', function() {
            // const loadComentsBtn = document.querySelector('.js-load-coments');
            // loadComentsBtn.addEventListener('click', loadComents);

            const countComentsBtn = document.querySelector('.js-comment-count');
            const countComentsBtnInner =  countComentsBtn.getElementsByTagName('hyvor-talk-comment-count')[0].innerHTML;
  
            if (countComentsBtnInner.indexOf("Comentários")) {
                countComentsBtn.getElementsByTagName('hyvor-talk-comment-count')[0].innerHTML = countComentsBtnInner.replace("Comentários", "");
            }

            const countComentsBtnH = document.querySelector('.js-comment-count-horizontal');
            const countComentsBtnInnerH =  countComentsBtn.getElementsByTagName('hyvor-talk-comment-count')[0].innerHTML;
            
            if (countComentsBtnInnerH.indexOf("Comentários")) {
                countComentsBtnH.getElementsByTagName('hyvor-talk-comment-count')[0].innerHTML = countComentsBtnInnerH.replace("Comentários", "");
            }
        });
    }
}
